import React, { useMemo } from 'react';
import { useInstantSearch } from 'react-instantsearch';
import { usePrevious } from 'react-use';

import BrowserOnly from 'components/consumer/BrowserOnly';
import { FABRIC_COLOR_CODES_MAP } from 'commons/constants';
import ProductListingColorFilter from '../../DesktopProductListingColorFilter/components/ProductListingColorFilter';
import MobileProductFilterWrapper from './MobileProductFilterWrapper';

/**
 * Color filter for mobile search filters modal.
 * Same logic as desktop (Algolia option_color + context selectedColors/selectColor),
 * compact display (grid like category page).
 */
const MobileProductListingColorFilter = ({
  colorFilters,
  refineColorFilters,
}) => {
  const { results } = useInstantSearch();

  const colors = useMemo(
    () =>
      Object.keys(FABRIC_COLOR_CODES_MAP).filter(c =>
        colorFilters.some(cf => cf.label?.toLowerCase() === c)
      ),
    [colorFilters]
  );

  const previousColors = usePrevious(colors);

  const displayColors = useMemo(() => {
    if (colors.length) {
      return colors;
    }
    if (results?.nbHits === 0) {
      return [];
    }
    return previousColors ?? [];
  }, [colors, results?.nbHits, previousColors]);

  if (!displayColors?.length) {
    return null;
  }

  return (
    <BrowserOnly>
      <MobileProductFilterWrapper id="color" label="Color">
        <ProductListingColorFilter
          colors={displayColors}
          colorFilters={colorFilters}
          refineColorFilters={refineColorFilters}
          showAsTwoRows
        />
      </MobileProductFilterWrapper>
    </BrowserOnly>
  );
};

export default MobileProductListingColorFilter;
